module.exports = __webpack_public_path__ + "static/img/06-assetsM.573eedf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/06-assetsM.png
// module id = tqNl
// module chunks = 1